import { render } from "./ModalCloseBatch.vue?vue&type=template&id=fa85360c&bindings={}"
import script from "./ModalCloseBatch.vue?vue&type=script&lang=ts"
export * from "./ModalCloseBatch.vue?vue&type=script&lang=ts"

import "./ModalCloseBatch.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script